import React from 'react';
import { TreeViewComponent } from '@syncfusion/ej2-react-navigations';

const TreeView = () => {
  // Sample data for TreeView
  const hierarchicalData =[
    {
      id: '01',
      name: 'Parent 1',
      children: [
        { id: '01-01', name: 'Child 1' },
        { id: '01-02', name: 'Child 2' },
      ],
    },
    {
      id: '02',
      name: 'Parent 2',
      children: [
        { id: '02-01', name: 'Child 1' },
        { id: '02-02', name: 'Child 2' },
      ],
    },
  ];
  
const onNodeClicked = (args) => {
  const clickedNode = args.nodeData;
  console.log(args)
  console.log(clickedNode)
  console.log('ID:', clickedNode.id);
  console.log('Name:', clickedNode.text);
};
const fields = { dataSource: hierarchicalData, id: 'id', text: 'name', child: 'children' };

  return (
    <div className='content-wrapper'>
      <h2>Syncfusion TreeView Example</h2>
      <TreeViewComponent fields={fields}  nodeSelecting={onNodeClicked}/>
    </div>
  );
};

export default TreeView;


// import * as React from 'react';
// import { enableRipple } from '@syncfusion/ej2-base';
// import { TreeViewComponent } from '@syncfusion/ej2-react-navigations';
// import './chart-of-account.scss';

// const TreeViewSample = () => {
//     enableRipple(true);

//     // Define the data for the TreeView
//     const data = {
//         defaultData: [
//             {
//                 id: "01", name: "Local Disk (C:)", expanded: true,
//                 subChild: [
//                     {
//                         id: "01-01", name: "Program Files",
//                         subChild: [
//                             { id: "01-01-01", name: "Windows NT" },
//                             { id: "01-01-02", name: "Windows Mail" },
//                             { id: "01-01-03", name: "Windows Photo Viewer" }
//                         ]
//                     },
//                     {
//                         id: "01-02", name: "Users", expanded: true,
//                         subChild: [
//                             { id: "01-02-01", name: "Smith" },
//                             { id: "01-02-02", name: "Public" },
//                             { id: "01-02-03", name: "Admin" }
//                         ]
//                     },
//                     {
//                         id: "01-03", name: "Windows",
//                         subChild: [
//                             { id: "01-03-01", name: "Boot" },
//                             { id: "01-03-02", name: "FileManager" },
//                             { id: "01-03-03", name: "System32" }
//                         ]
//                     }
//                 ]
//             },
//             {
//                 id: "02", name: "Local Disk (D:)",
//                 subChild: [
//                     {
//                         id: "02-01", name: "Personals",
//                         subChild: [
//                             { id: "02-01-01", name: "My photo.png" },
//                             { id: "02-01-02", name: "Rental document.docx" },
//                             { id: "02-01-03", name: "Payslip.pdf" }
//                         ]
//                     },
//                     {
//                         id: "02-02", name: "Projects",
//                         subChild: [
//                             { id: "02-02-01", name: "Blazor Application" },
//                             { id: "02-02-02", name: "TypeScript Application" },
//                             { id: "02-02-03", name: "React Application" }
//                         ]
//                     },
//                     {
//                         id: "02-03", name: "Office",
//                         subChild: [
//                             { id: "02-03-01", name: "Work details.docx" },
//                             { id: "02-03-02", name: "Weekly report.docx" },
//                             { id: "02-03-03", name: "Wishlist.csv" }
//                         ]
//                     }
//                 ]
//             },
//             {
//                 id: "03", name: "Local Disk (E:)", icon: "folder",
//                 subChild: [
//                     {
//                         id: "03-01", name: "Pictures",
//                         subChild: [
//                             { id: "03-01-01", name: "Wind.jpg" },
//                             { id: "03-01-02", name: "Stone.jpg" },
//                             { id: "03-01-03", name: "Home.jpg" }
//                         ]
//                     },
//                     {
//                         id: "03-02", name: "Documents",
//                         subChild: [
//                             { id: "03-02-01", name: "Environment Pollution.docx" },
//                             { id: "03-02-02", name: "Global Warming.ppt" },
//                             { id: "03-02-03", name: "Social Network.pdf" }
//                         ]
//                     },
//                     {
//                         id: "03-03", name: "Study Materials",
//                         subChild: [
//                             { id: "03-03-01", name: "UI-Guide.pdf" },
//                             { id: "03-03-02", name: "Tutorials.zip" },
//                             { id: "03-03-03", name: "TypeScript.7z" }
//                         ]
//                     }
//                 ]
//             }
//         ]
//     };

//     // Fields configuration for the TreeView
//     const fields = { dataSource: data.defaultData, id: 'id', text: 'name', child: 'subChild' };

//     return (
//         <div className='control-pane'>
//             <div className='control-section'>
//                 <div className='tree-control_wrapper'>
//                     {/* Render TreeView */}
//                     <TreeViewComponent fields={fields} />
//                 </div>
//             </div>
//         </div>
//     );
// };

// export default TreeViewSample;
